import React from 'react'
import { Form, Button, Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from '../Organizations.module.less'

interface Props {
  onSubmit: (values: any) => void
  onCancel: () => void
  initialData?: any | null
  isLoading?: boolean
}

export const CreateUpdateRoleForm: React.FC<Props> = ({
  onSubmit,
  onCancel,
  initialData,
  isLoading = false,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  // Set initial values
  React.useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        roleName: initialData.name,
      })
    } else {
      form.resetFields()
    }
  }, [initialData, form])

  const onFinish = (values: any) => {
    onSubmit && onSubmit(values)
    form.resetFields()
  }

  return (
    <>
      <Form
        className={styles.CreateUpdateForm}
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label={t('roleName')}
              name="roleName"
              rules={[{ required: true, message: t('roleNameRequired') }]}
            >
              <Input placeholder={t('roleManagement.enterRoleName')} />
            </Form.Item>
          </Col>
        </Row>
        <div className={styles.FooterModal}>
          <Button onClick={onCancel} disabled={isLoading}>
            {t('cancel')}
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {t('save')}
          </Button>
        </div>
      </Form>
    </>
  )
}